import { AxiosError } from 'axios';
import { GET_JOB_STATUS_RECORD_DETAILS_URL } from 'web-library/constants/apiUrls';
import axiosClient from '../axiosClient';
import { useCustomQuery } from '../utils/useCustomQuery';
import { GET_JOB_STATUS_RECORD_DETAILS_QUERY_KEY } from '../../constants/queryKeys';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface RecordStatusViewDetailsResponseModel {
  recordStatusErrorModel: RecordStatusErrorModel;
  jobStatusItemResponseModel: JobStatusItemResponseModel;
  uinfinPassportIndexNo: string;
  name: string;
  examLevel: string;
  applicationDateTime: string;
  applicationId: string;
}

interface RecordStatusErrorModel {
  errorCode: string;
  errorDescription: string;
}

interface JobStatusItemResponseModel {
  syncAttemptDate: string;
  noOfAttempts: string;
  recordStatus: DropdownListModel;
}

interface DropdownListModel {
  code: string;
  description: string;
}

// =============================================================================
// Query
// =============================================================================
interface Input {
  onSuccess?: (res: RecordStatusViewDetailsResponseModel) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
  uuid: string;
  errorDetailsOnly: boolean;
}

export const useGetJobStatusRecordDetails = ({
  onSuccess,
  onError,
  uuid,
  errorDetailsOnly,
}: Input) => {
  const getJobStatusRecordDetails = async () => {
    const res = await axiosClient.get<RecordStatusViewDetailsResponseModel>(
      GET_JOB_STATUS_RECORD_DETAILS_URL(uuid, errorDetailsOnly)
    );
    return res.data;
  };

  return useCustomQuery(GET_JOB_STATUS_RECORD_DETAILS_QUERY_KEY, getJobStatusRecordDetails, {
    onSuccess,
    onError,
    refetchOnMount: true,
    staleTime: 0,
  });
};
